import { useNavigate, useParams } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'
import { ConversationList } from '@/components/marketing/ConversationList'
import { ConversationDetailInline } from '@/components/marketing/ConversationDetailInline'

/**
 * Vista split del Inbox (estilo HighLevel):
 *   - 320px lista de conversaciones a la izquierda (búsqueda + filtros).
 *   - Resto del viewport: detalle de la conversación seleccionada o placeholder.
 *
 * Es la vista por defecto del Inbox: se monta en /marketing/inbox y
 * /marketing/inbox/:id (la vista flat clásica vive en /marketing/inbox-classic).
 */
export function InboxLayoutPage() {
  const { id } = useParams<{ id?: string }>()
  const navigate = useNavigate()

  function handleSelect(convId: string) {
    // Debe apuntar a la MISMA ruta montada en App.tsx (/marketing/inbox/:id).
    // Antes navegaba a /marketing/inbox-split/:id (nombre previo al rename) →
    // caía en el catch-all 404 y el detalle nunca se abría.
    navigate(`/marketing/inbox/${convId}`)
  }

  return (
    <div className="flex h-full min-h-0">
      <aside className="w-[320px] shrink-0 h-full min-h-0">
        <ConversationList selectedId={id} onSelect={handleSelect} />
      </aside>
      <main className="flex-1 flex h-full min-h-0">
        {id ? (
          <ConversationDetailInline conversationId={id} />
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center text-ink-700/50">
            <MessageSquare className="size-10 mb-3 opacity-30" />
            <p className="text-sm">Selecciona una conversación</p>
            <p className="text-xs font-mono mt-1">o usa el simulador para inyectar una nueva</p>
          </div>
        )}
      </main>
    </div>
  )
}
